import { ReactComponent as EmailIcon } from '../assets/icons/mail_outline_small_blue.svg';
import { ReactComponent as SelfReviewIcon } from '../assets/icons/self-assesment-small_purple.svg';
import { ReactComponent as TopDownReviewIcon } from '../assets/icons/top_down_review_small.svg';
import { ReactComponent as DownUpReviewIcon } from '../assets/icons/down_up_review_small.svg';
// import { ReactComponent as PeerReviewIcon } from '../assets/icons/peer_cycle.svg';
import { SURVEY_TYPES } from './survey';

export const INITIAL_SORT = {
  column: 'createdAt',
  asc: false,
  sortKey: '-created_at',
};

export const MANAGE_CYCLE_FIELD_NAMES = {
  ACTIVE_SETTINGS: 'activeSettings',
  CYCLE_STEPS: 'cycleSteps',
  IS_REPEATING: 'repeat',
  REPEAT_INTERVAL_UNIT: 'repeat_interval_unit',
  REPEAT_INTERVAL: 'repeat_interval',
  TITLE: 'title',
  USERS: 'users',
  FILTERS: 'filters',
};

export const STEP_GLOBAL_FIELDS = {
  ASSIGNMENTS: 'assignments',
  ATTRIBUTES: 'attributes',
  ATTRIBUTES_WITH_COMMENT: 'attributes_with_answer_comment',
  START_AT: 'start_at',
  END_AT: 'end_at',
  HAS_EMAIL: 'hasEmail',
};

export const EMAIL_STEP_FIELD_NAMES = {
  EMAIL_SUBJECT: 'email_title',
  EMAIL_MESSAGE: 'email_text',
};

export const CYCLE_STEP_TYPES = {
  EMAIL_STEP: 'EMAIL',
  SELF_REVIEW_STEP: 'SELF_REVIEW',
  TOP_DOWN_STEP: 'TOP_DOWN_REVIEW',
  DOWN_UP_STEP: 'BOTTOM_UP_REVIEW',
  PEER_REVIEW_STEP: 'PEER_REVIEW',
};

export const ASSIGNMENT_FIELDS = {
  REVIEWERS: 'reviewers',
  CREATED_FOR: 'created_for',
};

export const CYCLE_REVIEW_TYPES_MAP = [
  {
    id: SURVEY_TYPES.SELF,
    name: 'Self review',
    icon: SelfReviewIcon,
    key: 'selfReview',
  },
  {
    id: SURVEY_TYPES.TEAM,
    name: 'Top > Down review',
    icon: TopDownReviewIcon,
    key: 'topDownReview',
  },
  {
    id: SURVEY_TYPES.PEER,
    name: 'Down > Up review',
    icon: DownUpReviewIcon,
    key: 'downUpReview',
  },
];

export const CYCLE_STEPS_MAP = [
  {
    id: CYCLE_STEP_TYPES.EMAIL_STEP,
    name: 'Email',
    icon: EmailIcon,
    key: 'email',
  },
  {
    id: CYCLE_STEP_TYPES.SELF_REVIEW_STEP,
    name: 'Self review',
    shortName: 'Self',
    icon: SelfReviewIcon,
    key: 'selfReview',
  },
  {
    id: CYCLE_STEP_TYPES.TOP_DOWN_STEP,
    name: 'Top > Down review',
    shortName: 'Top > Down',
    icon: TopDownReviewIcon,
    key: 'topDownReview',
  },
  {
    id: CYCLE_STEP_TYPES.DOWN_UP_STEP,
    name: 'Down > Up review',
    shortName: 'Down > Up',
    icon: DownUpReviewIcon,
    key: 'downUpReview',
  },
  // {
  //   id: CYCLE_STEP_TYPES.PEER_REVIEW_STEP,
  //   name: 'Peer review',
  //   icon: PeerReviewIcon,
  //   key: 'peerReview',
  // },
];

export const INTERVAL_UNIT_TYPES = {
  MONTH: 'MONTH',
  WEEK: 'WEEK',
};

export const REPEAT_INTERVAL_OPTIONS = [
  {
    id: INTERVAL_UNIT_TYPES.MONTH,
    name: 'Month',
    key: 'month',
    periods: Array.from({ length: 12 }, (_, i) => ({
      id: i + 1,
      name: i + 1,
    })),
  },
  {
    id: INTERVAL_UNIT_TYPES.WEEK,
    name: 'Week',
    key: 'week',
    periods: Array.from({ length: 52 }, (_, i) => ({
      id: i + 1,
      name: i + 1,
    })),
  },
];
